import axios from "axios";
import {actionTypes} from "../../reducers/generalNoteStatusTypesReducer";

export const GET_NOTE_STATUS_TYPES = '/generalData/getGeneralNoteStatusTypes';

export const getNoteStatusTypes = () => dispatch => {
  return axios.get(GET_NOTE_STATUS_TYPES)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error();
      const generalNoteStatusTypes = body?.generalNoteStatusTypes ?? [];

      dispatch({
        type: actionTypes.getNoteStatusTypes,
        payload: {generalNoteStatusTypes},
      });

      return generalNoteStatusTypes
    })
};